export default "__VITE_ASSET__k0j7rkFu2IJCcvroynKGAA__"